export default __webpack_public_path__ + "static/media/Harness of the Blood Drinker.9bad3885.jpg";